// simple wrapper around browser fetch for swr
import fetch from 'cross-fetch'

const spektrixApiUrl = 'https://tickets.norden.farm/nordenfarm/api/v3'

const options = {
  // Fetch options (defaults)
  credentials: 'include',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
}

const SpektrixFetcher = url =>
  fetch(`${spektrixApiUrl}${url}`, options).then(res => res.json())

export default SpektrixFetcher
